import { Component, Injector } from '@angular/core';

import { DtoComponent, createDtoProperties, AuthorizationSchemeService, AuthorizationScheme } from '@mango/core';
import { Alert } from './alert';
import { AlertType } from './alert-type';
import { AlertService } from './alert.service';

@Component({
    selector: 'dla-app-alert',
    templateUrl: './alert.component.html'/*,
    styleUrls: ['./alert.component.css']*/
})
export class AlertComponent extends DtoComponent<Alert> {
    properties = createDtoProperties<Alert>([
        'title',
        'message',
        'date',
        'type',
        'expiringDate'        
    ]);

    alertType = AlertType;
    myScheme: AuthorizationScheme;
    
    constructor(
        service: AlertService,
        private authService: AuthorizationSchemeService,
        injector: Injector) {
        super(injector, service, Alert);
    }

    ngOnInit() {
        super.ngOnInit();
        this.myScheme = this.authService.getMyScheme();

        this.handleRoute("id", () => {
            if (this.myScheme.canRead("CIJBorculo.Logic.Alert")){
                if (!this.myScheme.canCreate("CIJBorculo.Logic.Alert")){
                    // Indien datumStart nog niet voorbij dan niet toegestaan
                    let currentDate = new Date();
                    let targetDate = new Date(this.item.date);
                    let diffDate = (targetDate.getTime() - currentDate.getTime())/86400000;

                    if (diffDate>0){
                        // Als customer dan geen rechten, terug naar het dashboard!
                        this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=>
                            this.router.navigateByUrl('/dashboard'));
                    }
                }
            }
        });
        
    }

    getType(value) {

		switch (Number(value)) {
			case AlertType.Notification:
				return "Bericht";
			default:
				return "";
		}
	}
}
